import {
  IBudget,
  IBudgetPaymentMethod,
} from 'modules/checkout/domain/entities';

export type TPaymentMethodBlock =
  | { blocked: false }
  | { blocked: true; reason: 'INELIGIBLE'; message?: string }
  | { blocked: true; reason: 'CUSTOMER_PENDENCIES' }
  | { blocked: true; reason: 'UNAVAILABLE' };

export default function getPaymentMethodBlockingReason(params: {
  budget: IBudget;
  method: IBudgetPaymentMethod;
  customerHasPendencies: boolean;
}): TPaymentMethodBlock {
  const { budget, method } = params;

  if (method.eligibility?.eligible === false) {
    return {
      blocked: true,
      reason: 'INELIGIBLE',
      message: method.eligibility.message,
    };
  }

  const isRecurring = method.key === 'RECURRING_CARD';

  if (isRecurring && params.customerHasPendencies) {
    return { blocked: true, reason: 'CUSTOMER_PENDENCIES' };
  }

  if (budget.disabledPaymentMethods.includes(method.key)) {
    return { blocked: true, reason: 'UNAVAILABLE' };
  }

  return { blocked: false };
}
